import { useConsole } from "contexts/Console"
import styled from "@emotion/styled"

import { body50, bold, light } from "css/text"
import { link } from "css/links"

const Para = styled.p`
  ${body50}
  ${light}

  .bold &,
  &.bold,
  b {
    ${bold}
  }

  a {
    ${link}
  }
`

export default function Paragraph({ text, className, block, is_bold }) {
  const console = useConsole()

  return block?.length ? (
    block.map(({ paragraph, is_bold }, i) => <Para key={i} className={`${is_bold ? "bold" : ""}`} dangerouslySetInnerHTML={{ __html: paragraph }} />)
  ) : (
    <Para className={`${className} ${is_bold ? "bold" : ""} paragraph`} dangerouslySetInnerHTML={{ __html: text }} />
  )
}
